import axios from "axios"

const baseURL = process.env.NEXT_PUBLIC_BACKEND_URL
const priceURL = process.env.NEXT_PUBLIC_NEMO_TWAP_PRICE_FEED
const nextApiURL = process.env.NEXT_PUBLIC_API || "http://localhost:3000/api"
export const api = axios.create({
  baseURL,
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
})

export const priceApi = axios.create({
  baseURL: priceURL,
})

export const nextApi = axios.create({
  baseURL: nextApiURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
})
